<template>
  <div class="eventExhibition">
    <div class="eventExhibition-content-title">
      <div class="title-left">{{ lan ? 'Exhibit' : '展出作品' }}</div>
    </div>
    <div class="eventExhibition-act-list">
      <div
        class="carousel-exhibit"
        @mousedown="startDrag"
        @mouseup="endDrag"
        @mouseleave="endDrag"
      >
        <div class="carousel-slides-exhibit" ref="slides" @mousemove="drag">
          <div
            v-for="(slide, index) in showData"
            :key="index"
            :class="{ 'carousel-slide': true, active: currentIndex === index }"
          >
            <img class="exhibit-pc" :src="slide.src" alt="" />
          </div>
        </div>
      </div>
      <div class="carousel-pagination">
        <div
          v-for="(_, index) in showData"
          :key="index"
          :class="{
            'carousel-pagination-button': true,
            active: currentIndex === index,
          }"
          @click="goToSlide(index)"
        ></div>
      </div>
    </div>
    <div class="work-info" v-for="(item, index) in showData" :key="index">
      <div class="work-title" v-if="currentIndex === index">
        {{ item.title }}
      </div>
      <div class="work-dec" v-if="currentIndex === index">
        <div v-for="(el, index) in item.labelList" :key="index">{{ el }}</div>
      </div>
      <!-- <div class="work-dec" v-if="currentIndex === index">
          {{ item.label }}
        </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showData: {
      type: Array,
      default: () => [], // 修正为返回空对象，但在此示例中未使用
    },
  },
  data() {
    return {
      isIndex: true,
      currentIndex: 0, // 当前显示的轮播图索引
      startX: 0,
      dragging: false,
      threshold: 50, // 滑动阈值，单位为像素
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  mounted() {
    if (this.isIndex) {
      window.addEventListener("touchstart", this.startDrag);
      window.addEventListener("touchmove", this.drag);
      window.addEventListener("touchend", this.endDrag);
    }
  },

  methods: {
    startDrag(event) {
      if (event.touches) {
        this.startX = this.isIndex ? event.touches[0].clientX : event.clientX;
      } else {
        this.startX = event.clientX;
      }
      this.dragging = true;
    },
    drag(event) {
      if (!this.dragging) return;
      let deltaX = 0;
      if (this.isIndex) {
        deltaX = event.touches[0].clientX - this.startX;
      } else {
        deltaX = event.clientX - this.startX;
        // 阻止默认滚动行为
        event.preventDefault();
      }
    },
    endDrag(event) {
      if (!this.dragging) return;
      let deltaX = 0;
      if (this.isIndex) {
        deltaX = event.changedTouches[0].clientX - this.startX;
      } else {
        deltaX = event.clientX - this.startX;
      }
      if (Math.abs(deltaX) > this.threshold) {
        if (deltaX > 0) {
          // 右滑，切换到上一张
          this.prevSlide();
        } else {
          // 左滑，切换到下一张
          this.nextSlide();
        }
      }

      this.dragging = false;
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.showData.length;
      this.$refs.slides.style.transform = `translateX(-${
        100 * this.currentIndex
      }%)`;
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex + this.showData.length - 1) % this.showData.length;
      this.$refs.slides.style.transform = `translateX(-${
        100 * this.currentIndex
      }%)`;
    },
    goToSlide(index) {
      this.currentIndex = index;
      this.$refs.slides.style.transform = `translateX(-${
        100 * this.currentIndex
      }%)`;
    },
  },
  beforeDestroy() {
    if (this.isIndex) {
      window.removeEventListener("touchstart", this.startDrag);
      window.removeEventListener("touchmove", this.drag);
      window.removeEventListener("touchend", this.endDrag);
    }
  },
};
</script>

<style scoped>
.eventExhibition-act-list {
    position: relative;
    width: 90%;
    margin: 0 auto;
  }
  .title-left {
    width: 90%;
    font-family: SourceHanSansCN-Bold;
    font-size: 26px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    margin: 30px auto 10px;
  }
  .carousel-exhibit {
    width: 100%;
    margin: 0 auto;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .carousel-slides-exhibit {
    display: flex;
    width: 100%; /* 假设有三个轮播项，每个轮播项宽100% */
    transition: transform 0.5s ease;
    color: #000;
  }
  .carousel-slides-exhibit .exhibit-pc {
    width: 100%;
    height: 20px;
    min-height: 340px;
    object-fit: cover;
  }

  .carousel-slide {
    flex: 0 0 100%;
    min-width: 100%;
    text-align: center;
    padding: 5px 0;
  }

  .carousel-slide.active {
    /* 实际上，由于我们使用了transform来定位活动轮播项，所以不需要这个类 */
  }

 .carousel-pagination {
    position: absolute;
    left: 20px;
    bottom: 20px;
    display: flex;
  }

  .carousel-pagination-button {
    margin: auto 4px !important;
    opacity: 1;
    width: 20px;
    height: 4px;
    background: url(../../assets/diandian_grey.png) no-repeat center;
    background-size: contain;
    cursor: pointer;
  }

  .carousel-pagination-button.active {
    width: 20px;
    height: 4px;
    background: none;
    position: relative;
    background: url(../../assets/diandian_highllight.png) no-repeat center;
    background-size: contain;
  }

  .carousel-control {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: #000;
    border: none;
    cursor: pointer;
    z-index: 10;
  }
  .work-info {
    width: 90%;
    margin: 10px auto 0;
    height: auto;
    text-align: left;
    overflow: hidden;
  }
  .work-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 20px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    margin-bottom: 10px;
  }
  .work-dec {
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #2c2c2c;
    letter-spacing: 0;
    text-align: left;
    line-height: 18px;
    font-weight: Regular;
  }
@media (max-width: 768px) {
  .eventExhibition-act-list {
    position: relative;
  }

  .carousel-exhibit {
    width: 100%;
    margin: 0 auto;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .carousel-slides-exhibit {
    display: flex;
    width: 100%; /* 假设有三个轮播项，每个轮播项宽100% */
    transition: transform 0.5s ease;
    color: #000;
  }
  .carousel-slides-exhibit .exhibit-pc {
    width: 100%;
    height: 20px;
    min-height: 340px;
    object-fit: cover;
  }

  .carousel-slide {
    flex: 0 0 100%;
    min-width: 100%;
    text-align: center;
   padding: 5px 0;
  }

  .carousel-slide.active {
    /* 实际上，由于我们使用了transform来定位活动轮播项，所以不需要这个类 */
  }

  .carousel-pagination {
    position: absolute;
    left: 20px;
    bottom: 20px;
    display: flex;
  }

  .carousel-pagination-button {
    margin: auto 2px !important;
    opacity: 1;
    width: 13px;
    height: 2.6px;
    background: url(../../assets/diandian_grey.png) no-repeat center;
    background-size: contain;
    cursor: pointer;
  }

  .carousel-pagination-button.active {
    width: 13px;
    height: 2.6px;
    background: none;
    position: relative;
    background: url(../../assets/diandian_highllight.png) no-repeat center;
    background-size: contain;
  }

  .carousel-control {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: #000;
    border: none;
    cursor: pointer;
    z-index: 10;
  }
  .work-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    margin-bottom: 6px;
  }
  .work-dec {
    font-family: SourceHanSansCN-Regular;
    font-size: 12px;
    color: #2c2c2c;
    letter-spacing: 0;
    text-align: left;
    line-height: 18px;
    font-weight: Regular;
  }
}
</style>